module.exports = {"542228100":"洛扎镇","542228101":"拉康镇","542228200":"生格乡","542228201":"边巴乡","542228202":"扎日乡","542228203":"色乡","542228204":"拉郊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542228.json
// module id = 2753
// module chunks = 0